module.exports = __webpack_public_path__ + "img/grey-media.0e3f11ca.jpg";